import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { Section } from "@react-email/components";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";
import { TextRenderer } from "@circle-react-shared/Emails/VisualEmailBuilder/EditorFields/RichTextField/TextRenderer";
import { useParseStyles } from "../../../Design/useParseStyles";
import { p1DefaultStyles as defaultStyles } from "./defaultStyles";

export type ParagraphStyle = "p1" | "p2" | "p3";
interface PProps extends ComponentPropsWithRef<"table"> {
  blockPath: string;
  "data-preview-mode": boolean;
  styles?: Record<string, StyleValue>;
  text: string;
}

export const P = forwardRef<HTMLTableElement, PProps>(
  (
    {
      text,
      styles = {},
      blockPath,
      "data-preview-mode": isPreviewMode,
      ...rest
    },
    ref,
  ) => {
    const parsedStyles = useParseStyles({
      styles,
      defaultStyles,
    });

    // Section component handles padding better than margin in email contexts
    // So we convert margin to padding for the Section wrapper
    const { margin, ...textStyles } = parsedStyles;

    const sectionStyles = margin ? { padding: margin } : {};

    return (
      <Section ref={ref} style={sectionStyles} {...rest}>
        <div style={textStyles}>
          <TextRenderer
            blockPath={blockPath}
            text={text}
            isPreviewMode={isPreviewMode}
          />
        </div>
      </Section>
    );
  },
);
P.displayName = "P";
